<div mat-dialog-content>
    <div class="docType-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-documentType (closeDialog)="onClose()" [docTypeformId]="docTypeformId"></app-documentType>
</div>